import PropTypes from 'prop-types';
import '../../css/absenceSummaryTable.scss';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const monthNames = [
  'GEN',
  'FEB',
  'MAR',
  'APR',
  'MAG',
  'GIU',
  'LUG',
  'AGO',
  'SET',
  'OTT',
  'NOV',
  'DIC',
];

const AbsencesYearlySummaryTable = ({ summary }) => {
  if (!summary) return null;

  const formatNumber = (num) => {
    if (num === null || num === undefined || num === '') return '';
    if (typeof num !== 'number') return num;
    if (Number.isInteger(num)) return num.toString();
    return num.toFixed(2).replace('.', ',');
  };

  // Prepara i dati mensili in un oggetto {mese: {ferie, permessi, assenze}}
  const monthly = Array(12)
    .fill(null)
    .map((_, i) => {
      const m = summary.monthlyDetails?.find((md) => md.month === i + 1);
      return {
        ferie: formatNumber(m?.ferie),
        permessi: formatNumber(m?.permessi),
        assenze: formatNumber(m?.assenze),
      };
    });

  return (
    <TableContainer component={Paper} sx={{ marginTop: '2px' }}>
      <Table className="absence-summary-table">
        <TableHead sx={{ height: '41px' }}>
          <TableRow>
            <TableCell>RIEPILOGO</TableCell>
            <TableCell>GG</TableCell>
            <TableCell style={{ borderRight: '2px solid #e0e0e0' }}>
              ORE
            </TableCell>
            {monthNames.map((m) => (
              <TableCell key={m}>{m}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Ferie</TableCell>
            <TableCell>{formatNumber(summary.totFerie / 8)}</TableCell>
            <TableCell style={{ borderRight: '2px solid #e0e0e0' }}>
              {formatNumber(summary.totFerie)}
            </TableCell>
            {monthly.map((m, idx) => (
              <TableCell key={idx} style={{ color: 'rgba(0, 0, 0, 0.38)' }}>
                {m.ferie}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell>Permessi</TableCell>
            <TableCell>{formatNumber(summary.totPermessi / 8)}</TableCell>
            <TableCell style={{ borderRight: '2px solid #e0e0e0' }}>
              {formatNumber(summary.totPermessi)}
            </TableCell>
            {monthly.map((m, idx) => (
              <TableCell key={idx} style={{ color: 'rgba(0, 0, 0, 0.38)' }}>
                {m.permessi}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell>Assenze</TableCell>
            <TableCell>{formatNumber(summary.totAssenze / 8)}</TableCell>
            <TableCell style={{ borderRight: '2px solid #e0e0e0' }}>
              {formatNumber(summary.totAssenze)}
            </TableCell>
            {monthly.map((m, idx) => (
              <TableCell key={idx} style={{ color: 'rgba(0, 0, 0, 0.38)' }}>
                {m.assenze}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

AbsencesYearlySummaryTable.propTypes = {
  summary: PropTypes.shape({
    totFerie: PropTypes.number,
    totPermessi: PropTypes.number,
    totAssenze: PropTypes.number,
    monthlyDetails: PropTypes.arrayOf(
      PropTypes.shape({
        month: PropTypes.number,
        ferie: PropTypes.number,
        permessi: PropTypes.number,
        assenze: PropTypes.number,
      })
    ),
  }),
};

AbsencesYearlySummaryTable.defaultProps = {
  summary: null,
};

export default AbsencesYearlySummaryTable;
